export default "__VITE_ASSET__CGEwxdwU__"